"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAP_HIGHLIGHT_TRANSPARENT = exports.S3_RESOURCE_ICONS = exports.BREAK_POINT = exports.PLATFORM = void 0;
var PLATFORM;

(function (PLATFORM) {
  PLATFORM["DESKTOP"] = "desktop";
  PLATFORM["PHONE"] = "phone";
})(PLATFORM = exports.PLATFORM || (exports.PLATFORM = {}));

var BREAK_POINT;

(function (BREAK_POINT) {
  BREAK_POINT[BREAK_POINT["MOBILE"] = 768] = "MOBILE";
})(BREAK_POINT = exports.BREAK_POINT || (exports.BREAK_POINT = {}));

exports.S3_RESOURCE_ICONS = 'https://dffoxz5he03rp.cloudfront.net/icons';
exports.TAP_HIGHLIGHT_TRANSPARENT = 'mrt-tap-highlight-transparent';